import CreateGeneTestForm from "@/views/PrintOrderForm/CreateGeneTestForm.vue"
import CreateConsentCancerForm from "@/views/PrintOrderForm/CreateConsentCancerForm.vue"
import CreateBloodSampleForm from "@/views/PrintOrderForm/CreateBloodSampleForm.vue"
import CreateRequireForm from "@/views/PrintOrderForm/CreateRequireForm.vue"
import CreateTestTicket from "@/views/PrintOrderForm/CreateTestTicket.vue"
import CreateExperimentTicket from "@/views/PrintOrderForm/CreateExperimentTicket.vue"
import CreateKtrackForm from "@/views/PrintOrderForm/CreateKtrackForm.vue"
import i18n from "@/libs/i18n"

export const ORDERS_STATUS = {
  RECEIVE_ORDERS: 1,
  PROCESSING: 2,
  // SENDING: 3,
  FINISHED: 3,
  CANCELED: 4,
  WAITING_CONFIRM: 6,
  ERROR_PAYMENT: 7,
}

export const ORDERS_PRODUCT_STATUS = {
  RECEIVE_ORDERS: 1,
  PROCESSING: 2,
  STOCK_OUT: 3,
  DELIVERY: 4,
  FINISH: 5,
  CANCELED: 100,
}

export const ORDER_DELIVERY_STATES = [
  { order_number: 1, date: null, max_steps: 5, title: "Chờ xử lý", title_done: 'Đã tiếp nhận' },
  { order_number: 2, date: null, max_steps: 5, title: "Chưa xử lý", title_done: 'Đã xử lý' },
  { order_number: 3, date: null, max_steps: 5, title: "Xuất kho", title_done: 'Đã xuất kho' },
  { order_number: 4, date: null, max_steps: 5, title: "Giao hàng", title_done: 'Đã giao hàng' },
  { order_number: 5, date: null, max_steps: 5, title: "Hoàn thành", title_done: 'Hoàn thành' },
]

export const DELIVERY_STATUS = {
  RECEIVED: 1,
  SAMPLE_TAKEN: 2,
  PROCESSING: 3,
  PAYMENT: 4,
  SENDING: 5,
  FINISHED: 6,
  DELIVERED: 7,
}

export const PRODUCT_TYPES = {
  PRODUCT: 1,
  SERVICE: 2,
}

export const PRODUCT_ON_HODO = {
  UNAVAILABLE: 1,
  PENDING_AVAILABLE: 2,
  AVAILABLE: 3,
  REJECT_AVAILABLE: 4,
  ARCHIVE_AVAILABLE: 50,
}

export const PRODUCT_ON_INVENTORY_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
}

export const PRODUCT_CERTIFICATES_STATES = {
  DRAFF: 0,
  WAITING: 1,
  VERIFIED: 2,
  REJECTED: 3,
}

export const ORDER_FORM_STATUS_OPTIONS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
}
export const SUPPLIER_ORDERS_STATUS = {
  CANCELED: 100,
}

export const MESSAGE_CODE_LOGIN_ERROR = 12345
export const MESSAGE_CODE_LOGIN_INCORRECT = i18n.t(
  "lbl_error_check_email_and_password"
)

export const ROLES_SYSTEM = {
  ALL: "All",
  SUPPLIER: 1,
  PROCESSOR: 2,
  SUPPLIER_PRODUCT: 3,
}

export const ORDER_FORM_CONFIG_STATUS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
}

export const ORDER_FORM_PROCESSOR_STATUS = {
  PENDING: 1,
  PROCESSING: 2,
  COMPLETE: 3,
  CANCEL: 4,
  SUPPLIER_CANCEL: 100,
}

export const HODOCONFIG_FIREBASE = {
  firebaseKey:
    "BB-wTadF8XkPvbqf0popurYLgNUiqE18PzDtyZCSLZD_INwc7ajHz8LDY4UXDieERpG5dyXMnnqyaHsq-qOOUpY",
}

export const RESULT_ORDER_ITEM_STATUS = {
  NOT_APPROVE: 1,
  APPROVE: 2,
}

export const ORDER_FORM_DRAFT = {
  REQUISITION_FORM: 1,
  RESULT_FORM: 2,
  RESULT_PROCESSOR: 3,
}

export const NOTIFICATION_TYPE = {
  SUPPLIER: 1,
  PROCESSOR: 2,
}

export const NOTIFICATION_STATUS_TYPE = {
  CREATE: 1,
  SUPPLIER_UPDATE: 2,
  PROCESSOR_UPDATE: 3,
  SUPPLIER_REJECT_LAB: 4,
  NEW_COMMENT: 5,
}

export const RESULT_FORM_TYPE = {
  SUPPLIER: 1,
  PROCESSOR: 2,
}

export const LIST_FORM = [
  {
    form_type: 12,
    name: "Phiếu đồng thuận thực hiện xét nghiệm tầm soát nguy cơ ung thư di truyền",
    component: CreateConsentCancerForm,
    print_preview_router: "print-consent-cancer-form"
  },
  {
    form_type: 13,
    name: "Phiếu đồng thuận xét nghiệm sàng lọc tiền sinh không xâm lấn - NIPT",
    component: CreateTestTicket,
    print_preview_router: "print-nipt"
  },
  {
    form_type: 14,
    name: "Phiếu mẫu máu, mẫu ối tươi, gai nhau",
    component: CreateBloodSampleForm,
    print_preview_router: "print-blood-sample-form"
  },
  {
    form_type: 15,
    name: "Phiếu đồng thuận thực hiện xét nghiệm G4500",
    print_preview_router: "print-g4500",
    component: CreateExperimentTicket
  },
  {
    form_type: 16,
    name: "Phiếu yêu cầu xét nghiệm",
    component: CreateRequireForm,
    print_preview_router: "print-require-form"
  },
  {
    form_type: 17,
    name: "Phiếu đồng thuận thực hiện xét nghiệm gen",
    component: CreateGeneTestForm,
    print_preview_router: "print-gene-test-form"
  },
  {
    form_type: 18,
    name: "Phiếu đồng thuận thực hiện xét nghiệm K-Track",
    component: CreateKtrackForm,
    print_preview_router: "print-ktrack"
  }
]
export const PAYMENT_TYPE = [
  {
    label: i18n.t("lbl_not_payment"),
    value: 1,
    class: "text-warning",
  },
  {
    label: i18n.t("lbl_paid"),
    value: 2,
    class: "text-success",
  },
  {
    label: i18n.t("lbl_canceled_bill"),
    value: 3,
    class: "text-danger",
  },
]

export const RECEIVING_TYPE = {
  receiving: 1,
  beginPeriod: 2,
}


export const PRODUCT_ORDER_STATUS = {
  RECEIVED: 1,
  PAYMENT: 2,
  STOCKOUT: 3,
  DELIVERIED: 4,
  SENDING: 5,
  FINISHED: 6,
  ARR: [
    1, 2, 3, 4, 5, 6
  ]
}

export const PAYMENT_METHOD = {
  offline: 1,
  online: 2,
  points: 3
}

export const ECOM_PRODUCT_PRESCRIPTION = {
  required: 2,
  unRequired: 1
}

export const ECOM_PRODUCT_VIEW = {
  view: 2,
  notView: 1
}


export const TYPE_CATE = {
  category: 1,
  dosage: 2,
  packaging: 3,
  unit: 4,
  manufacture: 5,
  brand: 6,
  origin: 7,
}

export const MARKETPLACE_PRODUCT_TYPES = {
  medicine: 1,
  others: 2
}